var map = {
	"./AboutView": [
		4402,
		402
	],
	"./AboutView.vue": [
		4402,
		402
	],
	"./HomeView": [
		3989,
		989
	],
	"./HomeView.vue": [
		3989,
		989
	],
	"./layout": [
		7475
	],
	"./layout/": [
		7475
	],
	"./layout/cu-aside": [
		2949
	],
	"./layout/cu-aside.vue": [
		2949
	],
	"./layout/cu-header": [
		9475
	],
	"./layout/cu-header.vue": [
		9475
	],
	"./layout/cu-main": [
		6396
	],
	"./layout/cu-main.vue": [
		6396
	],
	"./layout/index": [
		7475
	],
	"./layout/index.vue": [
		7475
	],
	"./service/address-settings": [
		7888,
		888
	],
	"./service/address-settings.vue": [
		7888,
		888
	],
	"./service/order-list": [
		1215,
		215
	],
	"./service/order-list.vue": [
		1215,
		215
	],
	"./service/profile-settings": [
		7308,
		308
	],
	"./service/profile-settings.vue": [
		7308,
		308
	],
	"./system/Login": [
		880,
		880
	],
	"./system/Login.vue": [
		880,
		880
	],
	"./system/NotFound": [
		1517,
		517
	],
	"./system/NotFound.vue": [
		1517,
		517
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6968;
module.exports = webpackAsyncContext;